import TencentCloudChat from '@tencentcloud/chat';
import { genTestUserSig } from './debug';



const SDKAppID = 1600061795;  // 接入时需要将0替换为您的即时通信 IM 应用的 SDKAppID
const userID = '100010204017'; // 您的 userID
const secretKey = "0d1cce06895eae7c61fe444dbaf5ea68b705cbfde52f5050ef4d964e2c2d0252"; // Your secretKey

const { userSig } = genTestUserSig({ SDKAppID, secretKey, userID }) // 用户登录即时通信 IM 的密码，其本质是对 UserID 等信息加密后得到的密文
const appKey = ''; // 推送服务 Push 的客户端密钥

console.log(userSig, '密文');

// 创建 SDK 实例，`TIM.create()`方法对于同一个 `SDKAppID` 只会返回同一份实例
export const chat = TencentCloudChat.create({
  SDKAppID,
}); // SDK 实例通常用 chat 表示

export function initChat() {
  chat.setLogLevel(0); // 普通级别，日志量较多，接入时建议使用
  // 登录 Chat
  let promise = chat.login({ userID, userSig });
  console.log('登录');  
  promise.then(function(imResponse) {
    console.log(imResponse.data, '登录成功'); // 登录成功
    if (imResponse.data.repeatLogin === true) {
      // 标识账号已登录，本次登录操作为重复登录。
      console.log(imResponse.data.errorInfo);
    }
  }).catch(function(imError) {
    console.warn('login error:', imError); // 登录失败的相关信息
  });
}

// export function getConversationList() {
//   // 获取全量的会话列表
//   let promise = chat.getConversationList();
//   promise.then(function(imResponse) {
//     // 全量的会话列表，用该列表覆盖原有的会话列表
//     const conversationList = imResponse.data.conversationList;
//     console.log(imResponse, '全量的会话列表');
//     // 从云端同步会话列表是否完成
//     const isSyncCompleted = imResponse.data.isSyncCompleted;
//     console.log(conversationList, '全量的会话列表');
//   }).catch(function(imError) {
//     // 获取会话列表失败的相关信息
//     console.warn('getConversationList error:', imError);
//   });
// }